import React from 'react'
import { Box, Typography, Tooltip, TooltipProps, tooltipClasses, styled } from '@mui/material'

export const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 600,
  },
})

export type AdminInfoRow = {
  label: string
  value: React.ReactNode
}

export function AdminInfoTooltipContent({
  title,
  rows,
  action,
}: {
  title: string
  rows: AdminInfoRow[]
  action?: React.ReactNode
}) {
  return (
    <Box>
      <Box borderBottom={1} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
        <Typography variant="body2" color={'textPrimary'}>
          {title}
        </Typography>
        {action}
      </Box>
      <Box>
        <Box
          display={'grid'}
          gridTemplateRows={`repeat(${rows.length}, 1fr)`}
          gridTemplateColumns={'1fr 5fr'}
          alignItems={'center'}
        >
          {rows.map((row) => (
            <React.Fragment key={row.label}>
              <Typography variant="body2" color={'textSecondary'}>
                {row.label}:
              </Typography>
              <Typography variant={'body1'} mx={'auto'} color={'textPrimary'}>
                {row.value}
              </Typography>
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
